import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import ICTHubPage from './pages/ICTHubPage';
import ProjectsPage from './pages/ProjectsPage';
import EstatePage from './pages/EstatePage';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ict-hub" element={<ICTHubPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/estate" element={<EstatePage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
